const index_splide_elm = document.querySelector('.index_splide')
if(index_splide_elm){
  const speed = Number(index_splide_elm.dataset.speed)
  const interval = Number(index_splide_elm.dataset.interval) 
  const index_splide = new Splide( index_splide_elm, {
    // type          : 'loop',
    type          : 'fade',
    rewind        : true,
    pagination    : false,
    arrows        : false,
    autoplay      : true,
    pauseOnHover  : false,
    interval      : interval,
    speed         : speed
  });
  index_splide.mount();
}

// faq script
      const headers = document.querySelectorAll('.accordion-header');
      const accordion = document.querySelector('.accordion');
      const openFirst = accordion?.dataset.openFirst === 'true';

      headers.forEach((header, index) => {
          header.addEventListener('click', () => {
              const content = header.nextElementSibling;

              // Close all other content
              document.querySelectorAll('.accordion-content').forEach(otherContent => {
                  if (otherContent !== content) {
                      otherContent.style.maxHeight = null;
                      otherContent.classList.remove('show');
                      otherContent.previousElementSibling.classList.remove('active');
                  }
              });

              // Toggle current content
              if (content.classList.contains('show')) {
                  content.style.maxHeight = null;
                  content.classList.remove('show');
                  header.classList.remove('active');
              } else {
                  content.style.maxHeight = content.scrollHeight + 'px';
                  content.classList.add('show');
                  header.classList.add('active');
              }
          });

          // Automatically open the first item if setting is enabled
          if (openFirst && index === 0) {
              const content = header.nextElementSibling;
              content.style.maxHeight = content.scrollHeight + 'px';
              content.classList.add('show');
              header.classList.add('active');
          }
      });

      // Ensure maxHeight updates correctly when resizing
      window.addEventListener('resize', () => {
          document.querySelectorAll('.accordion-content.show').forEach(content => {
              content.style.maxHeight = content.scrollHeight + 'px';
          });
      });


initSplideCarousels()


  let mainImagesHtml = "";
  let thumbnailsHtml = "";

setTimeout(() => {


  let strapDesingSelectedOption = document.querySelector('#strap-design-select');
  let selectedVariantWithStrapValue = '';

  window.addEventListener('strap-result-ready', (e) => {
    selectedVariantWithStrapValue = e.detail.result;
  });

  function updateFromSelectedImage() {
    const selectedImg = document.querySelector('.strap-images .splide__slide img.selected');
    if (!selectedImg) return;

    const currentValue = selectedImg.alt;

    let parts = selectedVariantWithStrapValue.split(' / ');
    parts[parts.length - 1] = currentValue;
    selectedVariantWithStrapValue = parts.join(' / ');

    getAndSetSlider(selectedVariantWithStrapValue)
  
  }

 
  strapDesingSelectedOption?.addEventListener('change', updateFromSelectedImage);

  const strapImages = document.querySelector('.strap-images');
  if (strapImages) {
    const observer = new MutationObserver(() => {
      updateFromSelectedImage();
      initSplideCarousels()
    });

    observer.observe(strapImages, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class']
    });
  }

  
});



const observer = new MutationObserver(() => {
  const el = document.querySelector('shopify-forms-embed');

  if (el && el.shadowRoot) {
    const btn_target = el.shadowRoot.querySelector('._teaserContainer_trejf_5');
    // const btn_targetWrap = el.shadowRoot.querySelector('._container_3eyaa_70._fadeAnimation_3eyaa_87');

    if (btn_target) {
      btn_target.style.setProperty('margin', '0', 'important');
      observer.disconnect(); // stop once done
    }
    // if (btn_targetWrap) {
    //   btn_targetWrap.style.setProperty('transform', 'translate(-50%, -38%)', 'important');
    //   observer.disconnect(); // stop once done
    // }
  }
});
observer.observe(document.body, {
  childList: true,
  subtree: true
});


// --- Fix #8: preload each flavour's main product photo so the ~1-2s
// image-swap delay is hidden behind normal browsing instead of happening
// after the customer clicks a color swatch. Fires once, shortly after
// page load, using the customer's CURRENT size + strap selection.
// Never throws, never blocks page load, never touches existing swap logic.
(function () {
  function preloadFlavourImages() {
    try {
      if (typeof productJSON === 'undefined' || !productJSON.metaImage) return;

      var checkedRadios = document.querySelectorAll('variant-selects fieldset input[type="radio"]:checked');
      var sizeVal = null;
      checkedRadios.forEach(function (r) {
        var legend = r.closest('fieldset')?.querySelector('legend');
        if (legend && /size/i.test(legend.textContent)) sizeVal = r.value;
      });

      var strapImg = document.querySelector('.strap-images .splide__slide img.selected');
      var strapSku = strapImg ? strapImg.alt : null;
      if (!sizeVal || !strapSku) return;

      var flavourValues = [];
      document.querySelectorAll('variant-selects fieldset').forEach(function (fs) {
        var legend = fs.querySelector('legend');
        if (legend && /flavour|color/i.test(legend.textContent)) {
          fs.querySelectorAll('input[type="radio"]').forEach(function (opt) {
            flavourValues.push(opt.value);
          });
        }
      });

      flavourValues.forEach(function (flavour) {
        var wantKey = (flavour + ' / ' + sizeVal + ' / ' + strapSku).toLowerCase();
        var match = productJSON.metaImage.find(function (item) {
          return Object.keys(item)[0].toLowerCase() === wantKey;
        });
        if (!match) return;
        var key = Object.keys(match)[0];
        var url = match[key] && match[key][0];
        if (!url) return;
        var img = new Image();
        img.src = url.indexOf('http') === 0 ? url : ('https:' + url);
      });
    } catch (e) {
      // fail silently — this is a background performance nicety, never critical
    }
  }

  if (document.readyState === 'complete') {
    setTimeout(preloadFlavourImages, 300);
  } else {
    window.addEventListener('load', function () {
      setTimeout(preloadFlavourImages, 300);
    });
  }
})();
